import { validateEnumTranslations } from '../../safety_checks';

export enum GenreType {
  MISTER = 'MISTER',
  MISS = 'MISS',
  MRS = 'MRS',
}

export const GenreTypeTranslation = {
  'fr-FR': {
    [`${GenreType.MISTER}`]: 'Monsieur',
    [`${GenreType.MISS}`]: 'Mademoiselle',
    [`${GenreType.MRS}`]: 'Madame',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(GenreType, GenreTypeTranslation, '', true);
